import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import OrgApi from "../api/organization";
import AuthorCard from "../author-card/author-card.vue";
import { Popover } from "@h3/antd-vue";
import getDownloadUrlNew from '../../../utils/getDownloadUrlNew';
// 二开开始
import Bus from "../../../../../form/utils/bus";
// 二开结束
let AuthorAvatarInfo = class AuthorAvatarInfo extends Vue {
    // 二开结束
    constructor() {
        super(...arguments);
        //   @Prop()sourceId?:string;
        //   @Prop()imgUrl!:any;
        //   @Prop()sourceName!:string;
        this.cardData = {}; //卡片数据
        // 二开开始
        this.isShowName = false;
        // 二开结束
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem("token");
    }
    returnClick(event) {
        return;
    }
    /**
     * 获取数据
     */
    authorChange(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log(id);
            this.cardData = {};
            const res = yield OrgApi.getOrgUserInfo({ id: id });
            if (res.errcode === 0) {
                this.cardData = res.data;
            }
        });
    }
    getDownloadUrlNew(refId) {
        return getDownloadUrlNew.getImageUrl(refId);
    }
    mounted() {
        Bus.$on('display', (val) => {
            if (this.item.colkey === 'names') {
                this.isShowName = !this.isShowName;
            }
        });
        let code = this.$route.query.code;
        if ((code === "salary_letter_config" || code === "salary_letter_report" || code === "hrbp_view") && this.item.colkey === 'names') {
            this.isShowName = false;
        }
        else {
            this.isShowName = true;
        }
    }
};
tslib_1.__decorate([
    Prop({ default: {
            sourceId: '',
            imgUrl: '',
            sourceName: '',
            onlyImg: false,
            colkey: ''
        } })
], AuthorAvatarInfo.prototype, "item", void 0);
tslib_1.__decorate([
    Prop()
], AuthorAvatarInfo.prototype, "entityType", void 0);
AuthorAvatarInfo = tslib_1.__decorate([
    Component({
        name: "author-avatar-info",
        components: {
            AuthorCard,
            APopover: Popover,
        },
    })
], AuthorAvatarInfo);
export default AuthorAvatarInfo;
